import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/auth/AuthContext";

const IntakesContext = createContext({ newCount: 0, refresh: () => {} });

export function IntakesProvider({ children }) {
  const { user } = useAuth();
  const isOwner = Boolean(user?.is_owner);
  const [newCount, setNewCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!isOwner) {
      setNewCount(0);
      return;
    }
    try {
      const res = await api.get("/intakes/count");
      setNewCount(res.data?.new || 0);
    } catch {
      /* non-fatal — keep last known count */
    }
  }, [isOwner]);

  useEffect(() => {
    refresh();
    if (!isOwner) return;
    const t = setInterval(refresh, 60000);
    return () => clearInterval(t);
  }, [refresh, isOwner]);

  return (
    <IntakesContext.Provider value={{ newCount, refresh }}>{children}</IntakesContext.Provider>
  );
}

export function useIntakes() {
  return useContext(IntakesContext);
}
